/*
utilities.js
This module contains shared helper functions such as debounce and clipboard utilities.
*/

export function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }
  
  export async function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        window.showToast('Profile link copied to clipboard!', 'success');
      } catch (err) {
        console.error('Clipboard error:', err);
        manualCopyFallback(text);
      }
    } else {
      manualCopyFallback(text);
    }
  }
  
  function manualCopyFallback(text) {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    tempTextArea.style.position = 'fixed';
    tempTextArea.style.left = '-9999px';
    document.body.appendChild(tempTextArea);
    tempTextArea.focus();
    tempTextArea.select();
    try {
      document.execCommand('copy');
      window.showToast('Profile link copied to clipboard!', 'success');
    } catch (copyErr) {
      console.error('Manual copy failed:', copyErr);
      window.showToast('Failed to copy link. Please copy manually.', 'danger');
    }
    document.body.removeChild(tempTextArea);
  }
  